import React from 'react';
import { LoadingSpinnerComponent } from './LoadingSpinner.styles.js';
import PropTypes from 'prop-types';

const LoadingSpinner = props => {
  return (
    <>
      <LoadingSpinnerComponent place={props.place}></LoadingSpinnerComponent>
      <div></div>
    </>
  );
};

LoadingSpinner.propTypes = {
  place: PropTypes.string,
};

export default LoadingSpinner;
